import * as Yup from "yup";

export const validationSchema = Yup.object({
  skus: Yup.array()
    .transform((field) => {
      // Removes the last row from validation and submission if it hasn't been fully populated.
      const finalValue = field[field.length - 1];
      if (
        finalValue !== undefined &&
        (finalValue.sku === null || finalValue.quantity === null)
      ) {
        return field.slice(0, -1);
      }
      return field;
    })
    .of(
      Yup.object({
        sku: Yup.object({
          id: Yup.string().required(),
        }).required(),
        quantity: Yup.number().moreThan(0).required(),
      }),
    ),
  locationId: Yup.string().required(),
});

export type FormValues = Yup.Asserts<typeof validationSchema>;
